@use "../../../scss/settings/colors";

.add_button {
  font-family: 'Medium Inter', sans-serif;
  text-transform: none !important;
  font-size: 0.75rem;
  color: colors.$base-white !important;
  background-color: colors.$brand-purple !important;
  border: 1px solid colors.$brand-purple;
  border-radius: 8px;
  box-shadow: none;
  padding: 12px;
  height: 115px; // Match supplier_card height
  min-height: unset;
  margin: 0;
  transition: background-color 0.3s, color 0.3s, border-color 0.3s;

  &:hover {
    color: colors.$brand-purple !important;
    background-color: colors.$base-white !important;
    border-color: colors.$brand-purple;
    box-shadow: none;
  }

  &:global(.Mui-disabled):hover, &[disabled]:hover {
    color: colors.$base-white !important;
    background-color: colors.$brand-purple !important;
    border-color: colors.$brand-purple !important;
  }
}

.grid_margin_bottom {
  margin-bottom: 2em !important;
  padding-top: 0 !important;
}

.page_title {
  color: colors.$base-black;
  font-size: 26px;
}

.subheader {
  color: colors.$base-black;
  margin-top: 2rem !important;
}

.customer_card {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  color: colors.$dark-blue !important;
  padding: 12px;
  width: 184px; // Fixed width
  height: 115px; // Fixed height
  cursor: pointer;
  position: relative;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden; // Prevent content overflow
}

.customer_card:hover {
  box-shadow: 0 8px 24px rgba(colors.$brand-purple, 0.15);
}

.customer_profile_icons {
  display: flex;
  flex-shrink: 0; // Icons won't shrink
  margin-top: auto; // Push to bottom
  svg {
    fill: colors.$gray-variant-11 !important;
  }
}

.customer_cards {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  margin-top: 2rem !important;
}

.form_box {
  position: absolute;
  z-index: 5;
  animation: pulse 0.5s ease-in-out;
  border-color: colors.$brand-purple;
}

.form_upload{
  border-color: colors.$brand-purple;
  margin-left: 32px;
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(1);
  }
}

// Customer name text handling - Enhanced with Option 1
.customer_name {
  height: 50px;
  max-height: 50px; // Strict limit
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 0.875rem;
  line-height: 1.3;
  font-weight: 400;
  color: colors.$dark-blue;
  word-break: break-word;
  transition: all 0.3s ease;
  flex-shrink: 0; // Prevent shrinking
  
  &.long_text {
    font-size: 0.75rem;
  }
}

.card_list_view_container {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 5px 8px;
  background-color: colors.$gray-variant-21;
  border-radius: 8px;
  border: 1px solid colors.$gray-variant-4;
}

.variant_btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  height: 32px;
  padding: 3px 6px;
  font-family: 'Medium Inter', sans-serif;
  font-size: 12px;
  text-transform: none;
  color: colors.$dark-blue;
  background-color: transparent;
  border-color: transparent;
  border-radius: 10px;
  transition: color 0.3s, background-color 0.3s;

  &[disabled]{
    opacity: 0.5;
  }

  &.variant_btn_active, &:hover {

    &:not([disabled]) {
      color: colors.$base-white;
      background-color: colors.$purple-light-5;
    }

  }

  svg {
    width: 16px;
    height: 16px;
    fill: currentColor !important;
  }

}

.table_container {
  box-shadow: none;
  border-radius: 8px;
  background-color: colors.$base-white !important;
}

.empty_message {
  max-width: 228px;
  margin-left: auto;
  margin-right: auto;
  font-family: "Light Inter", sans-serif;
  font-style: italic;
  font-size: 0.875rem;
  line-height: 1.3125rem;
  text-align: center;
  color: colors.$dark-blue;
}

.profile_container,
.file_type_container,
.date_container {
  display: flex;
  align-items: center;
  gap: 8px;

  svg {
    fill: colors.$dark-blue;;
  }

}

.profile_icon,
.file_type_icon {
  display: flex;
  align-items: center;
  color: colors.$dark-blue;

  svg {
    fill: colors.$dark-blue;
  }

  .MuiSvgIcon-root {
    width: 24px !important;
    height: 24px !important;
  }

}

.profile_icon {
  width: 24px;
  height: 24px;
  justify-content: center;
}


.actions_container {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  padding-left: 8px;

  .action_button {
    flex-shrink: 0;

    svg {
      fill: colors.$dark-blue !important;
    }


    &:hover {

      svg {
        fill: colors.$dark-blue !important;
      }

    }

  }

}

.header_cell {
  &.actions_header {
    text-align: right;
    padding-left: 24px;
  }
}

.badge_new {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  width: 45px;
  height: 20px;
  font-family: "Medium Inter", sans-serif;
  font-size: 12px;
  color: colors.$text-black-4;
  background-color: colors.$blue-variant-2;
  border-radius: 4px;
}

.table_row {
  border-bottom: 1px solid colors.$gray-variant-4;
  transition: border-color 0.3s;
  cursor: pointer;

  &.doc_new {

    td {
      border-color: colors.$brand-purple;

      &:first-child {
        border-left: 1px solid colors.$brand-purple;
      }

      &:last-child {
        border-right: 1px solid colors.$brand-purple;
      }

    }

    &:first-child {

      td {
        border-top: 1px solid colors.$brand-purple;
      }

    }

  }

}

.table_cell {
  padding: 16px;

  .cell_text {
    color: colors.$dark-blue;
  }

}

.profile_text {
  min-width: 100px;
  max-width: 150px;
  color: colors.$dark-blue;
}

.file_name_container {
  width: 295px;
  color: colors.$dark-blue;
}

.header_text {
  color: colors.$dark-blue;
}

.file_type_chip {
  border-radius: 16px;
  padding: 2px 8px;
  display: inline-block;
  font-size: 12px;
  font-weight: 500;
}

.date_container {
  display: flex;
  align-items: center;
  gap: 4px;

  .cell_text {
    white-space: nowrap;
  }

}

.green_label, .blue_label {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  padding: 2px 4px;
  font-family: 'Medium Inter', sans-serif;
  font-size: 12px;
  color: colors.$text-black;
  background-color: colors.$green-variant-light;
  border-radius: 4px;
}

.blue_label {
  background-color: colors.$blue-variant-2;}
